"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKatastrMap = exports.useProvideKatastrMap = exports.KatastrProvider = exports.useStayKatastrMap = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const leaflet_1 = __importDefault(require("leaflet"));
const react_1 = require("react");
const KatastrContext = (0, react_1.createContext)({
    active: false,
    setActive: () => { },
    initialized: false
});
const useStayKatastrMap = () => {
    const hook = (0, react_1.useContext)(KatastrContext);
    if (!hook.initialized) {
        throw new Error("useStayKatastrMap must be used within a KatastrProvider");
    }
    return hook;
};
exports.useStayKatastrMap = useStayKatastrMap;
const KatastrProvider = ({ children }) => {
    const panorama = (0, exports.useProvideKatastrMap)();
    return ((0, jsx_runtime_1.jsx)(KatastrContext.Provider, { value: panorama, children: children }));
};
exports.KatastrProvider = KatastrProvider;
const useProvideKatastrMap = () => {
    const [active, setActive] = (0, react_1.useState)(false);
    return {
        active,
        setActive,
        initialized: true
    };
};
exports.useProvideKatastrMap = useProvideKatastrMap;
const useKatastrMap = (map) => {
    const { active, setActive } = (0, exports.useStayKatastrMap)();
    (0, react_1.useEffect)(() => {
        if (active) {
            setKatastr();
        }
        else {
            setGeo();
        }
    }, [active]);
    const setGeo = () => {
        const ortoLayer = leaflet_1.default.tileLayer.wms("https://geoportal.cuzk.cz/WMS_ORTOFOTO_PUB/WMService.aspx", {
            layers: "GR_ORTFOTORGB",
            maxZoom: map.map?.getMaxZoom() || 10,
            styles: "",
            format: "image/png",
            transparent: true,
            version: "1.3.0",
            attribution: "ČÚZK"
        });
        map.setTileLayer(ortoLayer);
        setActive(false);
    };
    const setKatastr = () => {
        const ortoLayer = leaflet_1.default.tileLayer.wms("https://geoportal.cuzk.cz/WMS_ORTOFOTO_PUB/WMService.aspx", {
            layers: "GR_ORTFOTORGB",
            maxZoom: map.map?.getMaxZoom() || 10,
            styles: "",
            format: "image/png",
            transparent: true,
            version: "1.3.0",
            attribution: "ČÚZK"
        });
        const katastrLayer = leaflet_1.default.tileLayer.wms("https://services.cuzk.cz/wms/local-km-wms.asp", {
            layers: "RST_KN_I,RST_KMD_I,omp_i,parcelni_cisla_i,obrazy_parcel_i,hranice_parcel_i,dalsi_p_mapy_i,prehledka_kat_uz,prehledka_kat_prac,prehledka_kraju-linie",
            maxZoom: map.map?.getMaxZoom() || 10,
            styles: "",
            format: "image/png",
            transparent: true,
            version: "1.3.0",
            attribution: "ČÚZK"
        });
        map.setTileLayer(ortoLayer);
        map.addTileLayer(katastrLayer);
        // add filter grayscale, make it all white
        const container = katastrLayer.getContainer();
        if (container)
            container.style.filter = "grayscale(100%) brightness(1000%)";
        setActive(true);
    };
    return {
        setGeo,
        setKatastr
    };
};
exports.useKatastrMap = useKatastrMap;
